import React, { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Cookies from "universal-cookie";

import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Index from "./components/Index";
import InfoRegional from "./components/InfoRegional";
import InfoSolicitud from "./components/InfoSolicitud";
import Consolidado from "./components/Consolidado";
import InfoClasificacion from "./components/InfoClasificacion";
import InfoModalidad from "./components/InfoModalidad";
import InfoModular from "./components/InfoModular";
import InfoEstados from "./components/InfoEstados";
import SolicitudAdmin from "./components/SolicitudAdmin";
import ConsultarCaso from "./components/ConsultarCaso";
import InfoEspeciales from "./components/InfoEspeciales";
import ManualGestor from "./Manuales/ManualGestor";
import ManualComercial from "./Manuales/ManualComercial";
import ProtectedRoute from "./modals/ProtectRoute";
import ListaUsuarios from "./components/InfoUsuarios";

import "./App.css";
import "../src/css/sb-admin-2.css";
import "../src/css/sb-admin-2.min.css";

function App() {
  const cookies = new Cookies();

  const [tieneRegional, setTieneRegional] = useState(
    cookies.get("regional") && cookies.get("regional") !== ""
  );

  // Observa cambios en la cookie para re-renderizar
  useEffect(() => {
    const interval = setInterval(() => {
      const valor = cookies.get("regional");
      if (valor && valor !== "" && !tieneRegional) {
        setTieneRegional(true);
      }
    }, 1000); // verifica cada segundo (puedes ajustar este tiempo)

    return () => clearInterval(interval);
  }, [tieneRegional]);

  return (
    <Router>
      <div className="main">
        {tieneRegional && <Sidebar />}
        <br /> <br /> <br /> <br />
        <Routes>
          <Route
            path="/"
            element={
              tieneRegional ? (
                <Navigate to={`/InfoSolicitudes/${cookies.get("regional")}`} />
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/Index"
            element={
              <ProtectedRoute>
                <Index />
              </ProtectedRoute>
            }
          />
          <Route path="/InfoUsuarios/:id" element={<InfoSolicitud />} />
          <Route path="/InfoUsuarios" element={<ListaUsuarios />} />
          <Route path="/" element={<Login />} />
          <Route
            path="/InfoRegional"
            element={
              <ProtectedRoute>
                <InfoRegional />
              </ProtectedRoute>
            }
          />
          <Route path="/InfoSolicitudes/:id" element={<InfoSolicitud />} />
          <Route
            path="/Consolidado"
            element={
              <ProtectedRoute>
                <Consolidado />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InfoClasificacion"
            element={
              <ProtectedRoute>
                <InfoClasificacion />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InfoModalidad"
            element={
              <ProtectedRoute>
                <InfoModalidad />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InfoModular"
            element={
              <ProtectedRoute>
                <InfoModular />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InfoEstados"
            element={
              <ProtectedRoute>
                <InfoEstados />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SolicitudAdmin"
            element={
              <ProtectedRoute>
                <SolicitudAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ConsultaCaso"
            element={
              <ProtectedRoute>
                <ConsultarCaso />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InfoEspeciales"
            element={
              <ProtectedRoute>
                <InfoEspeciales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ManualGestor"
            element={
              <ProtectedRoute>
                <ManualGestor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ManualComercial"
            element={
              <ProtectedRoute>
                <ManualComercial />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
